import NoDataComponent from "@/views/components/CopyTrade/Unauthorized/NoDataComponent";

export default function PortfolioCopyFollowerNoDataPage(props: any) {
    return (
        <NoDataComponent title="Danh mục sao chép" />
    );
}